import React, { Component } from "react";
import { View, Text, Linking, Platform } from "react-native";
import { Button, LightButton } from "../../components/common";
import { connect } from "react-redux";
import { updateUserWithoutResponseRequest } from "@microdoing/shared/services/user/actions";
import Modal from "react-native-modal";
import i18n from "@microdoing/shared/i18n";
import moment from "moment";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import requestNotificationPermission from "@microdoing/shared/utils/requestNotificationPermission";
import hasNotificationPermission from "@microdoing/shared/utils/hasNotificationPermission.js";
import { getIsCoachingCampaign } from "@microdoing/shared/services/userCampaign/selectors";
import theme from "app/Theme/Theme";

class NotificationsModal extends Component {
  acceptNotifications = async () => {
    const { userId } = this.props;
    try {
      await requestNotificationPermission();
    } finally {
      // console.log(error);
      const enabled = await hasNotificationPermission();
      if (enabled) {
        this.props.triggerModal();
        this.props.updateUserWithoutResponseRequest({
          userId,
          hasNotificationsEnabled: true,
          hasNotificationsEnabledCheckDate: moment().toDate(),
        });
      } else {
        if (Platform.OS === "ios") {
          Linking.canOpenURL("app-settings:")
            .then(supported => {
              if (!supported) {
                console.log("Can't handle settings url");
              } else {
                return Linking.openURL("app-settings:");
              }
            })
            .catch(err => console.error("An error occurred", err));
        } else {
          Linking.openSettings();
        }
      }
    }

    this.props.triggerModal();
  };

  render() {
    const { isCoachingCampaign = false, firstName } = this.props;
    return (
      <Modal
        backdropTransitionOutTiming={0}
        isVisible={this.props.isVisible}
        keyboardShouldPersistTaps
        avoidKeyboard
        useNativeDriver
        onBackdropPress={this.props.triggerModal}
      >
        <View style={styles.modal}>
          <Text style={styles.header}>{i18n.t("activate-notifications")}</Text>
          <Text style={styles.text}>
            {isCoachingCampaign
              ? i18n.t("activate-notifications-explanation-coaching", {
                  firstName,
                })
              : i18n.t("activate-notifications-explanation", {
                  firstName,
                })}
          </Text>
          <View style={styles.buttonsView}>
            <LightButton
              text={i18n.t("refuse")}
              textPropStyle={styles.red}
              buttonPropStyle={styles.leftButton}
              onPress={this.props.triggerModal}
            />
            <Button
              text={i18n.t("activate")}
              onPress={this.acceptNotifications}
              textPropStyle={styles.bold}
              buttonPropStyle={styles.rightButton}
            />
          </View>
        </View>
      </Modal>
    );
  }
}

const styles = {
  header: {
    marginTop: 10,
    marginBottom: 15,
    color: theme.colors["neutral.900"],
    fontSize: wp("5%"),
    fontWeight: "bold",
  },
  text: {
    color: theme.colors["neutral.900"],
    fontSize: wp("4%"),
  },
  modal: {
    backgroundColor: theme.colors["neutral.white"],
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    padding: 15,
  },
  loadingView: {
    marginTop: 15,
    marginBottom: 15,
  },
  buttonsView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  leftButton: {
    marginTop: 20,
    borderColor: "red",
    width: wp("37%"),
  },
  rightButton: {
    marginTop: 20,
    width: wp("37%"),
  },
  red: {
    color: "red",
  },
  bold: {
    fontWeight: "bold",
  },
};

const mapStateToProps = state => {
  return {
    userId: getUserId(state),
    firstName: state.user.firstName,
    isCoachingCampaign: getIsCoachingCampaign(state),
  };
};

export default connect(mapStateToProps, { updateUserWithoutResponseRequest })(
  NotificationsModal,
);
